import { Component } from '@angular/core';
import { correctHeight, detectBody } from '../../../app.helpers';

declare var jQuery: any;

@Component({
    selector: 'basic',
    templateUrl: 'basic.template.html'
})
export class basicComponent {
    onResize(event) {
        const innerWidth = event.target.innerWidth;
        correctHeight();
        detectBody();
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/layouts/basic.component.ts